import React from "react";
import { Tooltip } from "@mui/material";
import { READ_ONLY_TOOLTIP_MESSAGE } from "@/utils/permissions";

interface Props {
  isReadOnly: boolean;
  message?: string;
  fullWidth?: boolean;
  children: React.ReactElement;
}

/**
 * 読み取り専用ユーザー向けのTooltipラッパー。
 * `isReadOnly`がtrueの時のみツールチップを表示する。
 * disabledなボタンでもツールチップが出るよう、`<span>`でラップしている。
 */
export const ReadOnlyTooltip: React.FC<Props> = ({
  isReadOnly,
  message,
  fullWidth = false,
  children,
}) => (
  <Tooltip
    title={isReadOnly ? message ?? READ_ONLY_TOOLTIP_MESSAGE : ""}
    placement="top"
    arrow
    disableHoverListener={!isReadOnly}
  >
    <span
      style={{
        display: "inline-flex",
        ...(fullWidth ? { width: "100%" } : {}),
      }}
    >
      {children}
    </span>
  </Tooltip>
);
